<template>
	<div>
		<div class="table_head">
			<div class="flex flex_between flex_1">
				<div>
					<md-button class="md-blank margin_r" @click="showSmartBundleNoticeModal">
						<i class="fa fa-paperclip btn_icon" aria-hidden="true"></i>
						{{ $t("SellTable.smartBundle.invoices") }}
					</md-button>
					<md-button class="md-blank margin_r" @click="uploadReceivables">
						<i class="fa fa-upload btn_icon" aria-hidden="true"></i>
						{{ $t("seller.sell.uploadReceivables") }}
					</md-button>
				</div>
				<el-dropdown @command="(command) => command()">
					<md-button class="md-blank">
						{{ $t("common.allSelected") }}<i class="el-icon-arrow-down el-icon--right"></i>
					</md-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item :command="clickSubmit">
							<i class="fa fa-paper-plane"></i> {{ $t("SellTable.button.startAuction") }}
						</el-dropdown-item>
						<el-dropdown-item :command="clickReset">
							<i class="fa fa-undo"></i> {{ $t("common.button.reset") }}
						</el-dropdown-item>
						<el-dropdown-item :command="bundle">
							<i class="fa fa-paperclip"></i> {{ $t("SellTable.Bundle.invoices") }}
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</div>
	</div>
</template>
<script>

import {navigationUtils} from "@/common/navigation/navigationUtils";
import {navigationPaths} from "@/common/navigation/navigationPaths";
import {navigationTabs} from "@/common/navigation/navigationTabs";

export default {
	props: {
		pageType: { type: String, default: "upload" },
		gridApi: Object
	},
	computed: {
	},
	methods: {
		smartBundle() {
			this.clickItem({ type: "smartBundle"});
		},
        showSmartBundleNoticeModal() {
			let option = {
				title: this.$t('SellTable.smartBundle.invoices'),
				msg: this.$t('SellTable.smartBundle.notice'), // TODO: Bundle - Get bundle params from config
				confirmFun: this.smartBundle,
  				customClass: 'msg_box_title_bold msg_box_title_center msg_box_width_l'
			};
			this.confirmMeg(option, true);
        },
		bundle: function() {
			this.clickItem({ type: "bundle"});
		},
		uploadReceivables() {
			this.$router.push(navigationUtils.getRouteWithActiveTab(navigationPaths.seller.sell, navigationTabs.seller.sell.upload));
		},
		clickSubmit() {
			this.clickItem({ type: "share" });
		},
		clickReset() {
			this.clickItem({ type: "del" });
		},
		clickItem(data) {
			let checkData = this.gridApi.getSelectedRows();
			if (data.type !== "setData" && data.type !== "bundle" && data.type !== "smartBundle" && checkData.length <= 0) {
				this.toast(this.$t("common.warning.needSelectRow"));
				return;
			}
			let anySelectedBelongsToInstallmentContract = checkData.some(data => data.installmentContractId);
			if (data.type === "del" && anySelectedBelongsToInstallmentContract) {
				this.toast(this.$t("SellTable.reset.belongsToInstallmentContract"));
				return;
			}
			this.$emit("checHead", {
				checkData: checkData,
				type: data.type
			});
		}
	}
};
</script>